/**
 * Sandbox bundler URL for Sandpack iframe.
 *
 * Resolution order:
 *   1. window.RC_CONFIG.SANDBOX_BUNDLER_URL  — set by /config.js at runtime
 *      (in containers this file is served from a K8s ConfigMap, so the value
 *      varies per env: dev / qa / prod)
 *   2. import.meta.env.VITE_SANDBOX_BUNDLER_URL  — build-time, used only for
 *      local dev (copy .env.development.example to .env.development to override,
 *      or inline: `VITE_SANDBOX_BUNDLER_URL=... npm run dev`)
 *   3. dev sandbox URL as last-resort fallback
 *
 * The window.RC_CONFIG type lives in src/types/global.d.ts.
 */
export const SANDBOX_BUNDLER_URL =
    window.RC_CONFIG?.SANDBOX_BUNDLER_URL ||
    import.meta.env.VITE_SANDBOX_BUNDLER_URL ||
    'https://sandbox.designdraft.dev.pwc.com';
